import Components from "views/Components/Components.jsx";
import LandingPage from "views/LandingPage/LandingPage.jsx";
import ProfilePage from "views/ProfilePage/ProfilePage.jsx";
import LoginPage from "views/LoginPage/LoginPage.jsx";
import LocationPage from "views/LocationPage/LocationPage.jsx";
import CalendarPage from "views/CalendarPage/CalendarPage.jsx";

var indexRoutes = [
  { path: "/landing-page", name: "LandingPage", component: LandingPage },
  { path: "/location", name: "LocationPage", component: LocationPage },
  { path: "/calendar", name: "CalendarPage", component: CalendarPage },
  { path: "/demo", name: "Demo", component: Components },
  { path: "/profile-page", name: "ProfilePage", component: ProfilePage },
  { path: "/login", name: "LoginPage", component: LoginPage },
  { path: "/", name: "LandingPage", component: LandingPage },
  { name: "default", component: LandingPage }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx